import { createSlice } from "@reduxjs/toolkit";
import { ICommunicationTemplatesSlice } from "../../models/admin/communicationTemplates/communicatinTemplates";
import {
  getAllCommunicationTemplates,
  getCommunicationTemplateversions,
} from "./CommunicationTemplatesActions";

const initialState: ICommunicationTemplatesSlice = {
  allCommunicationTemplates: [],
  templateVersions: [],
};

const CommunicationTemplatesSlice = createSlice({
  name: "CommunicationTemplatesSlice",
  initialState: initialState,
  reducers: {
    setTemplateVersions: (state, { payload }) => {
      state.templateVersions = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      getAllCommunicationTemplates.fulfilled,
      (state, { payload }) => {
        state.allCommunicationTemplates = payload.data;
      }
    );
    builder.addCase(
      getCommunicationTemplateversions.fulfilled,
      (state, { payload }) => {
        state.templateVersions = payload.data;
      }
    );
  },
});

export default CommunicationTemplatesSlice.reducer;
export const { setTemplateVersions } = CommunicationTemplatesSlice.actions;
